import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const APP_NAME = "Idarah";

/**
 * Maps route prefixes to page titles.
 * Order matters — more specific routes should come first.
 */
const routeTitleMap: { path: string; title: string }[] = [
    // Auth pages
    { path: "/login", title: "Login" },
    { path: "/signup", title: "Sign Up" },
    { path: "/change-password", title: "Change Password" },

    // Main pages
    { path: "/dashboard", title: "Dashboard" },
    { path: "/organization", title: "Organisation" },
    { path: "/settings", title: "Settings" },

    // Inventory
    { path: "/inventory", title: "Uniform & PPE" },

    // Assets
    { path: "/assets", title: "Assets" },

    // Departments
    { path: "/departments", title: "Departments" },

    // People — must come before generic /people to avoid false match on /people/:id
    { path: "/people", title: "People" },

    // Job Roles
    { path: "/job-roles", title: "Job Roles" },
    { path: "/job-roles/:id/edit", title: "Edit Job Role" },

    // Procedures
    { path: "/procedure", title: "Procedures" },
    { path: "/procedures", title: "Procedures" },

    // Activities
    { path: "/activities", title: "Activities" },

    // Training Plans
    { path: "/training-plans", title: "Training Plans" },

    // Policies (sub-routes first)
    { path: "/policy-edit", title: "Policies" },
    { path: "/policies/new-assign", title: "Policies" },
    { path: "/policies/assign", title: "Policies" },
    { path: "/policies/new", title: "Policies" },
    { path: "/policies", title: "Policies" },

    // My Policies
    { path: "/my-policies", title: "My Policies" },
    { path: "/memo-sign", title: "My Policies" },

    // Development
    { path: "/development", title: "Development" },

    // Memos
    { path: "/memos", title: "Memos" },

    // Help
    { path: "/help", title: "Help" },

    // Debug
    { path: "/debug", title: "Debug" },

    // Qualifications
    { path: "/qualifications", title: "Qualifications" },

    // Attendance
    { path: "/attendance", title: "Attendance & Leave" },

    // Systems
    { path: "/business-systems", title: "Business Systems" },

    // Finance
    { path: "/finance/direct-debit/settings", title: "Finance Settings" },
    { path: "/finance/direct-debit", title: "Direct Debits" },
];

export function usePageTitle() {
    const location = useLocation();

    useEffect(() => {
        const pathname = location.pathname;

        const matched = routeTitleMap.find((entry) => {
            if (pathname === entry.path) return true;
            if (pathname.startsWith(entry.path + "/")) return true;
            // Handle parameterized routes like /job-roles/:id/edit
            if (entry.path.includes('/:id')) {
                const regex = new RegExp('^' + entry.path.replace(/:id/g, '[^/]+') + '$');
                if (regex.test(pathname)) return true;
                const regexWithSlash = new RegExp('^' + entry.path.replace(/:id/g, '[^/]+') + '/');
                if (regexWithSlash.test(pathname)) return true;
            }
            return false;
        });

        if (matched) {
            document.title = `${matched.title} | ${APP_NAME}`;
        } else {
            document.title = APP_NAME;
        }
    }, [location.pathname]);
}
